import { render, staticRenderFns } from "./PriceSpArchitecture.vue?vue&type=template&id=8904f46e&scoped=true&"
import script from "./PriceSpArchitecture.vue?vue&type=script&lang=js&"
export * from "./PriceSpArchitecture.vue?vue&type=script&lang=js&"
import style0 from "./PriceSpArchitecture.vue?vue&type=style&index=0&id=8904f46e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8904f46e",
  null
  
)

export default component.exports